import React from "react";

const KodeKaryawanInput = React.forwardRef(
  (
    {
      label = "Kode Karyawan",
      name = "kodeKaryawan",
      value = "",
      onChange,
      kodeList = [],
      lastKode = "",
      error,
      ...props
    },
    ref
  ) => {
    const handleChange = (e) => {
      let angka = e.target.value.replace(/\D/g, "").slice(0, 6); // Hanya angka, max 6 digit
      const fullKode = `STN-${angka.padStart(6, "0")}`;
      const isDuplicate = kodeList.includes(fullKode);
      const errorMsg = isDuplicate ? "Kode sudah digunakan!" : "";
      onChange?.(angka, fullKode, errorMsg);
    };

    const displayValue = String(value).slice(0, 6); // Max 6 digit di display
    const fullKodePreview = `STN-${displayValue.padStart(6, "0")}`;
    const isDuplicate = kodeList.includes(fullKodePreview);

    return (
      <div className="flex flex-col">
        {label && (
          <label
            htmlFor={name}
            className="block mb-1 text-sm font-semibold text-green-800"
          >
            {label}
          </label>
        )}
        <div className="flex items-center overflow-hidden border border-gray-300 rounded-md">
          <span className="px-3 font-mono text-gray-700 bg-gray-100 select-none">
            STN-
          </span>
          <input
            id={name}
            name={name}
            type="text"
            ref={ref}
            className="flex-1 px-3 py-2 outline-none"
            value={displayValue}
            onChange={handleChange}
            placeholder="contoh: 000015"
            {...props}
          />
        </div>

        {isDuplicate && (
          <p className="mt-1 text-sm text-red-500">Kode sudah digunakan!</p>
        )}
        {error && <p className="mt-1 text-sm text-red-500">{error.message}</p>}
        {lastKode && (
          <p className="mt-1 text-sm text-gray-500">
            Kode terakhir yang digunakan: {lastKode}
          </p>
        )}
      </div>
    );
  }
);

export default KodeKaryawanInput;
